import { render } from "./StatTotalPage.vue?vue&type=template&id=4b76c516&scoped=true"
import script from "./StatTotalPage.vue?vue&type=script&lang=js"
export * from "./StatTotalPage.vue?vue&type=script&lang=js"

import "./StatTotalPage.vue?vue&type=style&index=0&id=4b76c516&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b76c516"]])

export default __exports__